<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            :color="color"
            title="Services"
            text="A table of Services"
          >
            <v-spacer/>

            <v-dialog
              v-model="dialog"
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-spacer />
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      v-model="search"
                      :loading="loading"
                      append-icon="search"
                      label="Search"
                      hide-details/>
                  </v-flex>
                </v-layout>
              </template>
              <v-card>
                <v-card-text>
                  <v-container grid-list-md >
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm12
                        md12>
                        <v-text-field
                          v-model="editedItem.name"
                          disabled
                          label="Service Name" />
                      </v-flex>

                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          v-model="editedItem.price"
                          disabled
                          type="number"
                          label="Price($)" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-select
                          :rules="[rules.required]"
                          v-model="editedItem.type"
                          :items="[
                          {id:'one-time', name:'One-Time'},{id: 'recurring', name: 'Recurring Every Month'}]"
                          disabled
                          item-text="name"
                          item-value="id"
                          label="Type"
                          dense
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12>
                        <v-textarea
                          v-model="editedItem.description"
                          disabled
                          label="Description" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12>
                        <v-checkbox
                          v-model="editedItem.active"
                          disabled
                          class="float-right"
                          label="Active"/>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headers"
              :items="ServiceList"
              :disable-initial-sort="true"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              class="elevation-1"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="editItem(props.item)">

                  <td>{{ props.item.id }}</td>
                  <td>
                    {{ props.item.name }}
                  </td>

                  <td>
                    {{ props.item.description }}
                  </td>
                  <td>${{ props.item.price }}</td>
                  <td>{{ props.item.type }}</td>
                  <td> <v-icon v-if="props.item.active">check</v-icon></td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'

  export default {
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    rules: {
      required: value => !!value || 'Required.',
      max256chars: v => v.length <= 256 || 'Input too long!'
    },
    pagination: {},
    ServiceList: [

    ],
    loading: true,

    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    search: '',
    headers: [
      {
        text: 'Id',
        align: 'left',
        value: 'id'
      },
      {
        text: 'Name',
        align: 'left',
        value: 'name'
      },
      {
        text: 'Description',
        align: 'left',
        value: 'description'
      },
      {
        text: 'Price($)',
        align: 'left',
        value: 'price'
      },
      {
        text: 'Type',
        align: 'left',
        value: 'type'
      },
      {
        text: 'Active',
        align: 'left',
        value: 'active'
      }
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      name: '',
      description: '',
      price: '',
      active: true
    },
    defaultItem: {
      id: '',
      name: '',
      description: '',
      price: '',
      active: true
    }
  }),

  computed: {
    ...mapState('app', ['color']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Service' : 'Edit Service'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  // called when page is created before dom
  created () {
    this.index()
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
  },

  methods: {
    index () {
      this.loading = true
      let self = this
      axios.get('/api/services')
              .then(response => {
                self.ServiceList = response.data
                self.loading = false
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.ServiceList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    deleteItem (item) {
      const index = this.ServiceList.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        axios.delete('/api/services/' + item.id)
                .then((response) => {
                  this.ServiceList.splice(index, 1)
                  this.deleteInline()
                          this.close()
                        }
                )
                .catch(error => {
                  if (error.response.status == '403') {
                    this.showError('Unauthorized')
                  } else {
                    this.showError(error.response.data.errors)
                  }
                  console.log(error)
                  this.cancelInline
                })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      // update
      if (this.editedItem.id !== '') {
        axios.put('/api/services/' + this.editedItem.id, this.editedItem)
          .then((response) => {
            Object.assign(this.ServiceList[this.editedIndex], response.data)
                this.saveInline()
              this.close()
              }
          )
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
          })
      }
      // create
      else {
        axios.post('/api/services', this.editedItem)
                .then((response) => {
                  this.ServiceList.unshift(response.data)
                  this.saveInline()
                  this.close()
                })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
          })
      }
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Service saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Service deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
